if (!customElements.get('bnpl-container')) {
  customElements.define(
    'bnpl-container',
    class BnplContainer extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.siteBody = document.querySelector('body')
        this.moreTrigger = this.querySelector('[data-bnpl-el="open-button"]')
        this.bnplDetails = this.querySelector('[data-bnpl-el="details"]')
        this.backToProduct = this.querySelector(
          '[data-bnpl-el="product-button"]',
        )
        this.closeButton = this.querySelector('[data-bnpl-el="close-button"]')
      }

      connectedCallback () {
        this.setupListeners()
      }

      setupListeners () {
        super.setupListeners()

        this.moreTrigger.addEventListener('click', this.openClick.bind(this))

        this.addEventListener('mouseover', this.openFocus.bind(this))

        this.addEventListener('mouseout', this.closeFocus.bind(this))

        this.backToProduct.addEventListener('click', this.closeinfo.bind(this))

        this.closeButton.addEventListener('click', this.closeinfo.bind(this))
      }

      openClick () {
        if (window.innerWidth < 901) {
          this.openInfo()
        }
      }

      openFocus () {
        if (window.innerWidth > 900) {
          this.openInfo()
        }
      }

      closeFocus () {
        if (window.innerWidth > 900) {
          this.closeinfo()
        }
      }

      openInfo () {
        this.siteBody.classList.add('bnpl-open')
        this.bnplDetails.classList.add('open')
      }

      closeinfo () {
        this.siteBody.classList.remove('bnpl-open')
        this.bnplDetails.classList.remove('open')
      }
    },
  )
}
